import { AgreementCode } from 'Constants/agreementCodes.constants';
import { BRAND_LOGO_URL } from '../themes.constants';
import { AkaUnion, Union } from '../themes.types';
import { BrandLogo, Cooperation, FooterAddon } from './partnerTheme.types';

export const AKA_UNION_TO_LOGO_FILE_NAME_MAP: {
  [key in Exclude<Union, undefined>]: string;
} = {
  akaAfag: 'akademikerne-afag-logo.svg',
  akaEcona: 'akademikerne-econa-logo.svg',
  akaLegeforeningen: 'akademikerne-legeforeningen-logo.svg',
  akaNaturviterne: 'akademikerne-naturviterne-logo.svg',
  akaNl: 'akademikerne-nl-logo.svg',
  akaPsykologiforeningen: 'akademikerne-psykologiforeningen-logo.svg',
  akaSamfunnsviterne: 'akademikerne-samfunnsviterne-logo.svg',
  akaSamfunnsøkonomene: 'akademikerne-samfunnsokonomene-logo.svg',
  akaTannlegeforeningen: 'akademikerne-tannlegeforeningen-logo.svg',
  akaVeterinærforeningen: 'akademikerne-vetrinaerforeningen-logo.svg',
};

export const AKA_AGREEMENT_CODE_TO_UNION_MAP: {
  [key: number]: Union;
} = {
  [AgreementCode.AKA_ARKITEKTENES_FAGFORBUND]: AkaUnion.AKA_AFAG,
  [AgreementCode.AKA_DEN_NORSKE_LEGEFORENING]: AkaUnion.AKA_LEGEFORENINGEN,
  [AgreementCode.AKA_DEN_NORSKE_TANNLEGEFORENING]:
    AkaUnion.AKA_TANNLEGEFORENINGEN,
  [AgreementCode.AKA_DEN_NORSKE_VETERINAERFORENING]:
    AkaUnion.AKA_VETERINÆRFORENINGEN,
  [AgreementCode.AKA_ECONA]: AkaUnion.AKA_ECONA,
  [AgreementCode.AKA_NATURVITERNE]: AkaUnion.AKA_NATURVITERNE,
  [AgreementCode.AKA_NORSK_LEKTORLAG]: AkaUnion.AKA_NL,
  [AgreementCode.AKA_NORSK_PSYKOLOGIFORENING]: AkaUnion.AKA_PSYKOLOGIFORENINGEN,
  [AgreementCode.AKA_SAMFUNNSVITERNE]: AkaUnion.AKA_SAMFUNNSVITERNE,
  [AgreementCode.AKA_SAMFUNNSOKONOMENE]: AkaUnion.AKA_SAMFUNNSØKONOMENE,
};

export const storebrandLogo: BrandLogo = {
  desktop: {
    src: BRAND_LOGO_URL.storebrand,
    alt: 'Storebrand logo',
  },
  mobile: {
    src: BRAND_LOGO_URL.storebrand,
    alt: 'Storebrand logo',
    style: {
      height: '20px',
      width: 'auto',
    },
  },
};

export const coopCooperation: Cooperation = {
  organization: 'Coop',
  logo: {
    src: BRAND_LOGO_URL.coop_rgb,
    height: '16px',
    alt: 'Coop logo rgb',
  },
};

export const danskeBankCooperation: Cooperation = {
  organization: 'Danske Bank',
  logo: {
    src: BRAND_LOGO_URL.danskeBank,
    height: '24px',
  },
};

export const storebrandFooterAddon: FooterAddon = {
  src: BRAND_LOGO_URL.storebrand,
  alt: 'Storebrand',
  height: '25px',
  width: 'auto',
};
